<template>

  <data-form
    :entity="formModel"
    :fields="fields"
    @change="onChange"
    @submit="onSubmit"
    :cancel="false"
    v-loading="loading"/>

</template>

<script>
import { post, get } from 'providers/http'

export default {
  name: 'ip-setup',
  data () {
    return {
      loading: true,
      formModel: {
        customDhcp: false,
        ipAddress: '',
        netmask: '',
        gateway: '',
        customPorts: false,
        serverProtocoll: 'https',
        serverPort: '3334',
        mqttPort: '8883',
        websocketPort: '3335'
      }
    }
  },
  computed: {
    fields () {
      let fields = {
        'customDhcp': {
          type: 'checkbox'
        },
        'ipAddress': {
          disabled: !this.formModel.customDhcp,
          type: 'text',
          rules: [{ max: 16 }]
        },
        'netmask': {
          disabled: !this.formModel.customDhcp,
          type: 'text',
          rules: [{ max: 16 }]
        },
        'gateway': {
          disabled: !this.formModel.customDhcp,
          type: 'text',
          rules: [{ max: 16 }]
        },
        'customPorts': {
          type: 'checkbox'
        },
        'serverProtocoll': {
          disabled: !this.formModel.customPorts,
          type: 'radio',
          options: [
            {
              value: 'http',
              label: 'serverProtocoll.http'
            },
            {
              value: 'https',
              label: 'serverProtocoll.https'
            }
          ]
        },
        'serverPort': {
          disabled: !this.formModel.customPorts,
          type: 'text',
          rules: [{ max: 5 }]
        },
        'mqttPort': {
          disabled: !this.formModel.customPorts,
          type: 'text',
          rules: [{ max: 5 }]
        },
        'websocketPort': {
          disabled: !this.formModel.customPorts,
          type: 'text',
          rules: [{ max: 5 }]
        }
      }

      return fields
    }
  },
  methods: {
    onChange (formModel) {
      this.formModel = formModel
    },
    async onSubmit (formModel) {
      try {
        await post('api/v1/servers/ip-setup', formModel)
        this.$emit('next')
      }
      catch (err) {
        console.error(err)
      }
    }
  },
  async beforeMount () {
    const status = await get('api/v1/status/lan')
    this.formModel.ipAddress = status.address
    this.formModel.netmask = status.netmask
    this.formModel.gateway = status.gatewayIp

    this.loading = false
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// IPSetup.vue?31e28850